"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../../utils");
const constants_1 = require("../constants");
const lodash_merge_1 = __importDefault(require("lodash.merge"));
const linkClickTrackingWithDynamicContexts = (enabled, dynamicEntities = [], additionalEntities = []) => {
    const plugin = constants_1.DEFAULT_PLUGINS.linkClickTracking;
    const enableConfiguration = (0, lodash_merge_1.default)(plugin.enableConfiguration, {
        context: [
            ...(0, utils_1.generateDynamicLinkClickContextFunctions)(dynamicEntities),
            ...additionalEntities,
        ],
    });
    plugin.enabled = enabled;
    plugin.enableConfiguration = enableConfiguration;
    return plugin;
};
exports.default = linkClickTrackingWithDynamicContexts;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGlua0NsaWNrVHJhY2tpbmdXaXRoRHluYW1pY0NvbnRleHRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3BsdWdpbnMvb3ZlcnJpZGVzL2xpbmtDbGlja1RyYWNraW5nV2l0aER5bmFtaWNDb250ZXh0cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztBQUNBLHVDQUF1RTtBQUd2RSw0Q0FBK0M7QUFDL0MsZ0VBQWlDO0FBRWpDLE1BQU0sb0NBQW9DLEdBQUcsQ0FDekMsT0FBZ0IsRUFDaEIsa0JBQWtDLEVBQUUsRUFDcEMscUJBQTZFLEVBQUUsRUFDbkUsRUFBRTtJQUNkLE1BQU0sTUFBTSxHQUFHLDJCQUFlLENBQUMsaUJBQWlCLENBQUM7SUFDakQsTUFBTSxtQkFBbUIsR0FBRyxJQUFBLHNCQUFLLEVBQUMsTUFBTSxDQUFDLG1CQUFtQixFQUFFO1FBQzFELE9BQU8sRUFBRTtZQUNMLEdBQUcsSUFBQSxnREFBd0MsRUFBQyxlQUFlLENBQUM7WUFDNUQsR0FBRyxrQkFBa0I7U0FDeEI7S0FDSixDQUFDLENBQUM7SUFFSCxNQUFNLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQztJQUN6QixNQUFNLENBQUMsbUJBQW1CLEdBQUcsbUJBQW1CLENBQUM7SUFFakQsT0FBTyxNQUFNLENBQUM7QUFDbEIsQ0FBQyxDQUFDO0FBRUYsa0JBQWUsb0NBQW9DLENBQUMifQ==


// WEBPACK FOOTER //
// ../../../../src/plugins/overrides/linkClickTrackingWithDynamicContexts.ts